module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEX09fdfpZSRAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg=="